import { FactoryIcon } from './FactoryIcon';

/**
 * author: Austin Andrews
 * id B74F1DE6-5DEC-4866-AEED-DE85FE09C52F
 * name factory
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/factory.svg
 * tags
 * - Places 
 * - Hardware / Tools 
 */
export const IndustrialIcon = FactoryIcon;
export default IndustrialIcon